<template>
  <v-sheet
    height="100%"
    class="position-relative carousel-home-item"
    width="100%"
    tile
  >
    <img class="d-block carousel-home-item-img" :src="img" :alt="title" />

    <div
      class="
        d-flex
        align-center align-lg-start
        justify-center
        carousel-home-item-caption
      "
    >
      <v-container>
        <div class="mx-auto ml-lg-0">
          <div class="carousel-home-item-caption-informations">
            <div class="pa-5">
              <div
                class="
                  white--text
                  text-h5 text-md-h4 text-uppercase
                  pb-3
                  mb-3
                  font-weight-medium
                "
                v-if="title"
              >
                {{ title }}
              </div>

              <div class="d-flex justify-center mt-5" v-if="details">
                <template v-for="({ icon, text }, index) in details">
                  <div
                    v-if="text"
                    :key="index"
                    class="d-flex align-center"
                    :class="{ 'ml-3 ml-md-7': index }"
                  >
                    <v-icon size="16" left class="white--text">
                      {{ icon }}
                    </v-icon>

                    <div class="white--text text-body-2 font-weight-bold">
                      <span class="font-secondary">
                        {{ text }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <v-btn
              height="54"
              :to="to"
              class="
                d-flex
                align-center
                secondary
                text-body-1 text-md-h6
                white--text
                carousel-home-caption-btn
              "
              tile
              text
            >
              VER DETALHES DO IMÓVEL
              <v-icon size="14" right> fa fa-chevron-right </v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    district: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      default: () => [],
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-home-item {
  &:before {
    background-color: rgba(10, 10, 10, 0.2);
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &-img {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }

  &-caption {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;

    &-informations {
      background-color: rgba(55, 52, 53, 0.6);
      margin-top: 200px;
      margin-top: calc(137px + 10vh);
      max-width: 100%;
      min-width: 430px;
      position: relative;
      width: min-content;
      z-index: 990;

      @media screen and (max-width: 1264px) {
        margin-top: 0;
        margin-bottom: 70px;
      }

      @media screen and (max-width: 960px) {
        margin-left: auto;
        margin-right: auto;
      }

      @media screen and (max-width: 600px) {
        margin-bottom: 0;
        min-width: 320px;
      }

      &-title {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        line-height: 1.4;
        width: 100%;
      }
    }

    &-btn {
      letter-spacing: initial;
      text-transform: none;
    }
  }
}
</style>
